import React, { useEffect, useState } from 'react';
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { JSONRecordData } from '../Log/graph.util';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { FormattedMessage } from 'react-intl';
import { I_S3Credentials } from '../../../interfaces/S3Types';
import routes from '../../../Resources/routes.json';
import CircularProgress from '@mui/material/CircularProgress';
import { I_Installation } from 'src/interfaces/InstallationTypes';

interface BatteryViewSodioHomeProps {
  values: JSONRecordData;
  s3Credentials: I_S3Credentials;
  installationId: number;
  installation: I_Installation;
  connected: boolean;
}

function BatteryViewSodioHome(props: BatteryViewSodioHomeProps) {
  if (props.values === null && props.connected == true) {
    return null;
  }

  const currentLocation = useLocation();
  const navigate = useNavigate();
  const inverter = (props.values as any)?.InverterRecord;
  const batteryClusterNumber = props.installation.batteryClusterNumber;
  const sortedBatteryView = inverter
    ? Array.from({ length: batteryClusterNumber }, (_, i) => {
      const index = i + 1; // Battery1, Battery2, ...

      return {
        BatteryId: String(index),
        battery: {
          Voltage: inverter[`Battery${index}Voltage`],
          Current: inverter[`Battery${index}Current`],
          Power: inverter[`Battery${index}Power`],
          Soc: inverter[`Battery${index}Soc`],
          Soh: inverter[`Battery${index}Soh`],
        }
      };
    })
    : [];

  const [loading, setLoading] = useState(sortedBatteryView.length == 0);
  const handleMainStatsButton = () => {
    navigate(routes.mainstats);
  };

  useEffect(() => {
    if (sortedBatteryView.length == 0) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [sortedBatteryView]);

  return (
    <>
      {!props.connected && (
        <Container
          maxWidth="xl"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh'
          }}
        >
          <CircularProgress size={60} style={{ color: '#ffc04d' }} />
          <Typography
            variant="body2"
            style={{ color: 'black', fontWeight: 'bold' }}
            mt={2}
          >
            Unable to communicate with the installation
          </Typography>
          <Typography variant="body2" style={{ color: 'black' }}>
            Please wait or refresh the page
          </Typography>
        </Container>
      )}
      {loading && props.connected && (
        <Container
          maxWidth="xl"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '70vh'
          }}
        >
          <CircularProgress size={60} style={{ color: '#ffc04d' }} />
          <Typography
            variant="body2"
            style={{ color: 'black', fontWeight: 'bold' }}
            mt={2}
          >
            Battery service is not available at the moment
          </Typography>
          <Typography variant="body2" style={{ color: 'black' }}>
            Please wait or refresh the page
          </Typography>
        </Container>
      )}

      {!loading && props.connected && (
        <Container maxWidth="xl">
          <Grid container>
            <Grid
              item
              xs={6}
              md={6}
              sx={{
                display:
                  !currentLocation.pathname.includes('detailed_view') &&
                  !currentLocation.pathname.includes('mainstats')
                    ? 'block'
                    : 'none'
              }}
            >
              <Button
                variant="contained"
                sx={{
                  marginTop: '20px',
                  backgroundColor: '#808080',
                  color: '#000000',
                  '&:hover': { bgcolor: '#f7b34d' }
                }}
              >
                <FormattedMessage
                  id="battery_view"
                  defaultMessage="Battery View"
                />
              </Button>

              <Button
                variant="contained"
                onClick={handleMainStatsButton}
                sx={{
                  marginTop: '20px',
                  marginLeft: '20px',
                  backgroundColor: '#ffc04d',
                  color: '#000000',
                  '&:hover': { bgcolor: '#f7b34d' }
                }}
              >
                <FormattedMessage id="main_stats" defaultMessage="Main Stats" />
              </Button>
            </Grid>
          </Grid>

          {/*<Grid container>*/}
          {/*  <Routes>*/}
          {/*    <Route*/}
          {/*      path={routes.mainstats + '/*'}*/}
          {/*      element={*/}
          {/*        <MainStats*/}
          {/*          s3Credentials={props.s3Credentials}*/}
          {/*          id={props.installationId}*/}
          {/*        ></MainStats>*/}
          {/*      }*/}
          {/*    />*/}
          {/*    {product === 0*/}
          {/*      ? Object.entries(props.values.Battery.Devices).map(*/}
          {/*          ([BatteryId, battery]) => (*/}
          {/*            <Route*/}
          {/*              key={routes.detailed_view + BatteryId}*/}
          {/*              path={routes.detailed_view + BatteryId}*/}
          {/*              element={*/}
          {/*                <DetailedBatteryView*/}
          {/*                  batteryId={Number(BatteryId)}*/}
          {/*                  s3Credentials={props.s3Credentials}*/}
          {/*                  batteryData={battery}*/}
          {/*                  installationId={props.installationId}*/}
          {/*                  productNum={product}*/}
          {/*                ></DetailedBatteryView>*/}
          {/*              }*/}
          {/*            />*/}
          {/*          )*/}
          {/*        )*/}
          {/*      : Object.entries(props.values.Battery.Devices).map(*/}
          {/*          ([BatteryId, battery]) => (*/}
          {/*            <Route*/}
          {/*              key={routes.detailed_view + BatteryId}*/}
          {/*              path={routes.detailed_view + BatteryId}*/}
          {/*              element={*/}
          {/*                <DetailedBatteryViewSodistore*/}
          {/*                  batteryId={Number(BatteryId)}*/}
          {/*                  s3Credentials={props.s3Credentials}*/}
          {/*                  batteryData={battery}*/}
          {/*                  installationId={props.installationId}*/}
          {/*                  productNum={product}*/}
          {/*                ></DetailedBatteryViewSodistore>*/}
          {/*              }*/}
          {/*            />*/}
          {/*          )*/}
          {/*        )}*/}
          {/*  </Routes>*/}
          {/*</Grid>*/}

          <TableContainer
            component={Paper}
            sx={{
              marginTop: '20px',
              marginBottom: '20px',
              display:
                !currentLocation.pathname.includes('detailed_view') &&
                !currentLocation.pathname.includes('mainstats')
                  ? 'block'
                  : 'none'
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Battery</TableCell>
                  <TableCell align="center">Power</TableCell>
                  <TableCell align="center">Battery Voltage</TableCell>
                  <TableCell align="center">Current</TableCell>
                  <TableCell align="center">SoC</TableCell>
                  <TableCell align="center">SoH</TableCell>
                  {/*<TableCell align="center">Daily Charge Energy</TableCell>*/}
                  {/*<TableCell align="center">Daily Discharge Energy</TableCell>*/}
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedBatteryView.map(({ BatteryId, battery }) => (
                  <TableRow
                    key={BatteryId}
                    style={{
                      height: '10px'
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      align="center"
                      sx={{ fontWeight: 'bold' }}
                    >
                      <Link
                        style={{ color: 'black' }}
                        to={routes.detailed_view + BatteryId}
                      >
                        {'Battery Cluster ' + BatteryId}
                      </Link>
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '13%',
                        textAlign: 'center'
                      }}
                    >
                      {battery.Power + ' ' + 'W'}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '13%',
                        textAlign: 'center',
                        backgroundColor:
                          battery.Voltage < 32 || battery.Voltage > 63
                            ? '#FF033E'
                            : '#32CD32',
                        color: 'inherit'
                      }}
                    >
                      {battery.Voltage + ' V'}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '13%',
                        textAlign: 'center',
                        backgroundColor: '#32CD32',
                        color: 'inherit'
                      }}
                    >
                      {battery.Current + ' A'}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '8%',
                        textAlign: 'center',
                        backgroundColor:
                          battery.Soc > 20
                            ? '#32CD32'
                            : battery.Soc >= 10
                              ? '#ffbf00'
                              : '#FF033E',
                        color: 'inherit'
                      }}
                    >
                      {battery.Soc + ' %'}
                    </TableCell>
                    <TableCell
                      sx={{
                        width: '8%',
                        textAlign: 'center',
                        backgroundColor:
                          battery.Soh ==100
                            ? '#32CD32'
                            : battery.Soc >= 90
                              ? '#ffbf00'
                              : '#FF033E',
                        color: 'inherit'
                      }}
                    >
                      {battery.Soh + ' %'}
                    </TableCell>
                    {/*<TableCell*/}
                    {/*  sx={{*/}
                    {/*    width: '15%',*/}
                    {/*    textAlign: 'center',*/}
                    {/*    backgroundColor: '#32CD32',*/}
                    {/*    color: 'inherit'*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  {battery.DailyChargeEnergy + ' Wh'}*/}
                    {/*</TableCell>*/}
                    {/*<TableCell*/}
                    {/*  sx={{*/}
                    {/*    width: '15%',*/}
                    {/*    textAlign: 'center',*/}
                    {/*    backgroundColor: '#32CD32',*/}
                    {/*    color: 'inherit'*/}
                    {/*  }}*/}
                    {/*>*/}
                    {/*  {battery.DailyDischargeEnergy + ' Wh'}*/}
                    {/*</TableCell>*/}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      )}
    </>
  );
}

export default BatteryViewSodioHome;
